module.exports = __webpack_public_path__ + "img/koshien.da7b3257.png";